import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';
import { selectGetemailsPromoters } from '@mm/state/selectors/promoterSelector';
import { StoreState } from '@mm/state/store-interfaces';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ChannelType } from '../../../../../liveChat/components/ChannelIcon';
import { TriggerType } from './TriggersDefinitions';
import { useChannelConnection } from './use-channel-connection';
import { useInputTriggerCRUD } from './use-input-trigger-crud';

export const useSuggestedInputTriggers = ({
  campaignId,
}: {
  campaignId: number;
}) => {
  const [toCreate, setToCreate] = useState<TriggerType>();

  const campaign = useSelector((state: StoreState) =>
    state.campaigns.entities.find(c => c.id === campaignId),
  );
  const promoters = useSelector(selectGetemailsPromoters);

  const createXRay = () => {
    if (campaign) {
      createInputTriggerAndOpenSlideout(
        campaign,
        'web_visitor_email_detector',
        undefined,
        !promoters.length,
      );
    }
  };

  const createCsvUpload = () => {
    if (campaign) {
      createInputTriggerAndOpenSlideout(campaign, 'import_contacts');
    }
  };

  const onChannelConnected = () => {
    switch (toCreate) {
      case 'import_contacts':
        return createCsvUpload();
      case 'web_visitor_email_detector':
        return createXRay();
    }

    setToCreate(undefined);
  };

  const { isSMSConnected, isEmailConnected, connectChannel } =
    useChannelConnection(onChannelConnected);

  const { createInputTriggerAndOpenSlideout } = useInputTriggerCRUD();

  const { pixelName: whitelabelPixelName } = useWhitelabelConfig();
  const pixelName = whitelabelPixelName
    ? `${whitelabelPixelName} Lead Generator`
    : 'X-Ray Lead Generation Pixel';

  return [
    {
      type: 'getemails',
      channel: ChannelType.email,
      active: true,
      showActivateAction: true,
      label: pixelName,
      subtitle: 'Capture leads form your anonymous website visitors',
      onClick: () => {
        if (!isEmailConnected) {
          setToCreate('web_visitor_email_detector');
          connectChannel('email');
          return;
        }

        createXRay();
      },
    },
    {
      type: 'contacts_csv',
      channel: ChannelType.csv,
      active: true,
      showActivateAction: true,
      label: 'Upload CSV',
      subtitle: 'MyContacts.csv',
      onClick: () => {
        if (!isEmailConnected) {
          setToCreate('import_contacts');
          connectChannel('email');
          return;
        }

        createCsvUpload();
      },
    },
  ];
};
